<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>



<div class="modal-signup modal-content max-width-80pe border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-10px border-bottom-1px">

        <div class="row" *ngIf="SelectedpatientDetails">
          <div class="col-md-2 ">
            <img class=" margin-left-6px image-width-scans" [src]="SelectedpatientDetails.OwnerPatientImageFile" onError="this.src='dummy.jpg';">
          </div>
          <div class="col-md-4 padding-left-0px">
            <div class="row row-height-17px margin-left-0px">
              <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                <label class="margin-bottom-0px font-weight-normal color-secondary">{{SelectedpatientDetails.OwnerName}} </label>
              </div>
            </div>
            <div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType=='DONOR' || SelectedpatientDetails.EggSourceType=='Donor'">
              <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(for : {{SelectedpatientDetails.EggName}}) </label>
              </div>
            </div>
            <!--<div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType==''">
              <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
              </div>
            </div>-->
            <div class="row row-height-17px">
              <div class="col-md-12">

                <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.OwnerAgeYears}},{{SelectedpatientDetails.OwnerFormattedCode}}</label>
              </div>
            </div>
            <div class="row row-height-17px">
              <div class="col-md-4">
                <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.OwnerTelephone1}}</label>
              </div>
            </div>
            <div class="row row-height-17px">
              <div class="col-md-3 padding-right-0px">
                <label class="font-size-12px margin-bottom-0px font-weight-normal">Cycle#{{SelectedpatientDetails.CycleNo}},</label>
              </div>
              <div class="col-md-9 padding-left-0px">
                <label class="font-size-12px margin-bottom-0px font-weight-normal">Start Date: {{SelectedpatientDetails.ProtocolStartDate | date:'MMM-dd-yyyy'}}</label>
              </div>

            </div>

          </div>
          <div class="col-md-5  padding-right-0px">
            <!--<div class="row font-size-12px">
              <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Check In </label>
              </div>:
              <div class="col-md-3 padding-right-0px padding-left-10px" *ngIf="FollicularData2">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">{{FollicularData2.LastUpdatedTime | date: 'hh:mm a'}}</label>
              </div>
            </div>-->
            <div class="row font-size-12px">
              <div class="col-md-7 margin-left-auto text-align-right padding-right-10px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Status </label>
              </div>:
              <div class="col-md-2 padding-right-0px padding-left-10px" *ngIf="SemanAnalysis2">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">{{SemanAnalysis2.ActivityStatus}}</label>
              </div>
            </div>
            <!--<div class="row font-size-12px" *ngIf="FollicularPickupEndInfo">
              <div class="col-md-7 margin-left-auto text-align-right padding-right-10px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Pickup Date </label>
              </div>:
              <div class="col-md-2 padding-right-0px padding-left-10px" *ngIf="FollicularPickupEndInfo">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">{{FollicularPickupEndInfo.OvumPickupdate | date:'MMM-dd-yyyy'}}</label>
              </div>
            </div>-->
            <!--<div class="row">
              <div class="col-md-1 margin-left-auto padding-left-7px">
                <div class=""><label class="margin-bottom-0px font-weight-normal">D</label></div>
                </div>
              <div class="col-md-1 padding-left-7px">
                <div class=""><label class="margin-bottom-0px font-weight-normal">S</label></div>
              </div>

               <div class="col-md-1 padding-left-7px">

                <div class=""><label class="margin-bottom-0px font-weight-normal">A</label></div>
              </div>

            </div>-->
            <div class="row margin-right-0px" hidden>
              <div class="Dsa1 margin-left-auto" *ngIf="DSADetails">
                <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.DOC}}</label>
              </div>
              <div class="Dsa2" *ngIf="DSADetails">
                <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.STIMULATION}}</label>
              </div>
              <div class="Dsa3" *ngIf="DSADetails">

                <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.ANTAG}}</label>
              </div>

            </div>
          </div>
          <div class="col-md-1">
            <button type="button" class="close button:focus" data-dismiss="modal"
                    (click)="activeModal.close('Load')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <!--{{ sectionData.Title }}-->


      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-top-0px padding-left-0px">
        <div class="card">

          <div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px">
            <div class="row nav-link-hand margin-right-0px margin-left-0px" id="edit-link">
              <div class="col-md-6 padding-right-0px">
                <label class="margin-bottom-0px font-size-16px font-weight-normal">
                  Semen Analysis
                </label>
              </div>
              <div class="col-md-5  padding-right-0px " *ngIf="GradingModel && SelectedpatientDetails">
                <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->
                <div class="row float-right" *ngIf="GradingModel=='Well Culture'">
                  <div class="col-md-11 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2">
                    <!--<a class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-normal display-edit" (click)="pickup()" title="Is Pickup Confirmed" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Is Pickup Confirmed</a>-->
                    <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit"
                       (click)="SemenAnalysis()" title="Semen Analysis Completed"
                       *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Semen Analysis Completed</a>
                  </div>

                  <!--<div class="col-md-1">
                    <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printsource()">
                      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                    </a>
                  </div>-->
                </div>

                <div class="row float-right" *ngIf="GradingModel=='Droplet Culture' && SelectedpatientDetails.CycleType!=='IUI'">
                  <div class="col-md-12 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2">
                    <!--<a class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-normal display-edit" (click)="pickup()" title="Is Pickup Confirmed" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Is Pickup Confirmed</a>-->
                    <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit"
                       (click)="SemenAnalysis()" title="Semen Analysis Completed"
                       *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Semen Analysis Completed</a>
                  </div>

                  <!--<div class="col-md-1">
                    <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printsourcedroplet()">
                      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                    </a>
                  </div>-->
                </div>

                <div class="row float-right" *ngIf="GradingModel=='Droplet Culture' && SelectedpatientDetails.CycleType=='IUI'">
                  <div class="col-md-12 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2">
                    <!--<a class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-normal display-edit" (click)="pickup()" title="Is Pickup Confirmed" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Is Pickup Confirmed</a>-->
                    <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit"
                       (click)="SemenAnalysisIUI()" title="Semen Analysis Completed"
                       *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Semen Analysis Completed</a>
                  </div>

                  <!--<div class="col-md-1">
                    <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printsourcedroplet()">
                      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                    </a>
                  </div>-->
                </div>
              </div>

            </div>
          </div>
          <div class="chatsd product-chart-wrapper product-chat-follicular-popup agreement-chart-wrapper ps  padding-lrt " data-ps-id="dfsfsde">
            <div class="card-body">
              <div *ngIf="SpermEndInfo && SemanAnalysis2">
                <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                  <div class="accordion margin-bottom-20px" id="accordionExample" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                Source Details
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="SemanAnalysis2">
                            <button type="button"
                                    class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="submit"
                                    [disabled]="!f.valid"
                                    class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right"
                                    *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">
                            Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                          </div>
                        </div>


                      </div>

                      <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px" *ngIf="GradingModel">

                          <div class="row my-profile-form" *ngIf="GradingModel=='Well Culture'">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                              <div class="row">
                                <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Male Source </label>
                                </div>


                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="IVFSP" (ngModelChange)="onChange2($event)" id="SpermEndInfo.SpermSource"
                                                 [(ngModel)]="SpermEndInfo.SpermSource" SelectedValue="SpermEndInfo.SpermSource"
                                                 name="SpermEndInfo.SpermSource" required>

                                  </CodeTypeValue>


                                </div>
                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="IVSSF" (ngModelChange)="onChange($event)" id="SpermEndInfo.SpermSourceFrom"
                                                 [(ngModel)]="SpermEndInfo.SpermSourceFrom" SelectedValue="SpermEndInfo.SpermSourceFrom"
                                                 name="SpermEndInfo.SpermSourceFrom" required>

                                  </CodeTypeValue>


                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row my-profile-form" *ngIf="GradingModel=='Droplet Culture'">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                              <div class="row">
                                <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Source of Sperm  </label>
                                </div>


                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="IVFSR" (ngModelChange)="onChange2($event)" id="SpermEndInfo.SpermSource"
                                                 [(ngModel)]="SpermEndInfo.SpermSource" SelectedValue="SpermEndInfo.SpermSource" required
                                                 name="SpermEndInfo.SpermSource">

                                  </CodeTypeValue>


                                </div>
                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="IVSSF" (ngModelChange)="onChange($event)" id="SpermEndInfo.SpermSourceFrom"
                                                 [(ngModel)]="SpermEndInfo.SpermSourceFrom" SelectedValue="SpermEndInfo.SpermSourceFrom" required
                                                 name="SpermEndInfo.SpermSourceFrom">

                                  </CodeTypeValue>


                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row margin-top-5px" *ngIf="SelectedSource=='Frozen' && SelectedValue=='Donor'">
                            <div class="col-md-3 text-align-right margin-top-4px">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Select Donor</label>
                            </div>
                            <div class="col-md-4">
                              <!--<input type="text" class="form-control" placeholder="Recommended Package">-->
                              <label class="margin-top-7px font-size-12px margin-left-10px" *ngIf="patientName">{{patientName}}</label>

                            </div>
                            <div class="col-md-2 padding-left-0px margin-top-5px">
                              <!--<div class="thick-circle4 nav-link-hand">
                                <a>
                                  <i class="fas fa-ellipsis-h"></i>
                                </a>
                              </div>-->
                              <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3   " (click)="SelectDonorForEgg()"> <i class="fas fa-ellipsis-h"></i></button>
                            </div>

                          </div>
                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Extraction Date </label>
                                </div>


                                <div class="col-md-3">

                                  <div class="date-form">
                                    <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                           name="dp2" [(ngModel)]="ExtractionDate" ngbDatepicker #d2="ngbDatepicker" #DateOfBirth="ngModel">
                                    <small class="form-text text-danger"
                                           *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                    <a (click)="d2.toggle()" class="nav-link-hand">
                                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                    </a>

                                  </div>

                                </div>

                              </div>


                            </div>
                          </div>
                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Extraction Time </label>
                                </div>


                                <div class="col-md-3">

                                  <input type="text" class="form-control" id="SpermEndInfo.ExtractionTimeText" placeholder="Extraction Time"
                                         [(ngModel)]="SpermEndInfo.ExtractionTimeText"
                                         name="SpermEndInfo.ExtractionTimeText" #ExtractionTimeText="ngModel" />

                                </div>

                              </div>


                            </div>
                          </div>

                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Storage Location </label>
                                </div>


                                <div class="col-md-3">

                                  <input type="text" class="form-control" placeholder="Storage Location" id="SpermEndInfo.StorageLocationDetails"
                                         [(ngModel)]="SpermEndInfo.StorageLocationDetails"
                                         name="SpermEndInfo.StorageLocationDetails" #Size="ngModel"
                                         maxlength="100">

                                </div>

                              </div>


                            </div>
                          </div>
                          <div class="row my-profile-form" *ngIf="GradingModel=='Well Culture'">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Technique </label>
                                </div>




                                <div class="col-md-5">
                                  <CodeTypeValue CodeType="IVFSR" id="SpermEndInfo.SpermRetrieval"
                                                 [(ngModel)]="SpermEndInfo.SpermRetrieval" SelectedValue="SpermEndInfo.SpermRetrieval"
                                                 name="SpermEndInfo.SpermRetrieval" required>

                                  </CodeTypeValue>


                                </div>



                              </div>


                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div *ngIf="SpermEndInfo && SemanAnalysis2">
                <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                  <div class="accordion margin-bottom-20px" id="accordionExample" *ngIf="SemanAnalysis2.ActivityStatus =='Completed'">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px"
                                      type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                Source Details
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="SemanAnalysis2">
                            <button type="button"
                                    class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                          </div>
                        </div>


                      </div>

                      <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px" *ngIf="GradingModel">

                          <div class="row my-profile-form" *ngIf="GradingModel=='Well Culture'">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                              <div class="row">
                                <div class="col-md-3  text-align-right margin-top-3px ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Male Source </label>
                                </div>:


                                <div class="col-md-3 margin-top-3px">
                                  <!--<CodeTypeValue CodeType="IVFSP" (ngModelChange)="onChange2($event)" id="SpermEndInfo.SpermSource"
                                                 [(ngModel)]="SpermEndInfo.SpermSource" SelectedValue="SpermEndInfo.SpermSource"
                                                 name="SpermEndInfo.SpermSource" required>

                                  </CodeTypeValue>-->

                                  <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.SpermSource}}</label>

                                </div>
                                <div class="col-md-3 margin-top-3px">
                                  <!--<CodeTypeValue CodeType="IVSSF" (ngModelChange)="onChange($event)" id="SpermEndInfo.SpermSourceFrom"
                                                 [(ngModel)]="SpermEndInfo.SpermSourceFrom" SelectedValue="SpermEndInfo.SpermSourceFrom"
                                                 name="SpermEndInfo.SpermSourceFrom" required>

                                  </CodeTypeValue>-->

                                  <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.SpermSourceFrom}}</label>

                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row my-profile-form" *ngIf="GradingModel=='Droplet Culture'">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                              <div class="row">
                                <div class="col-md-3  text-align-right margin-top-3px ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Source of Sperm  </label>
                                </div>:


                                <div class="col-md-3 margin-top-3px">
                                  <!--<CodeTypeValue CodeType="IVFSR" (ngModelChange)="onChange2($event)" id="SpermEndInfo.SpermSource"
                                                 [(ngModel)]="SpermEndInfo.SpermSource" SelectedValue="SpermEndInfo.SpermSource"
                                                 name="SpermEndInfo.SpermSource" required>

                                  </CodeTypeValue>-->

                                  <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.SpermSource}} ({{SpermEndInfo.SpermSourceFrom}})</label>

                                </div>

                              </div>


                            </div>
                          </div>

                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3  text-align-right margin-top-3px ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Extraction Date </label>
                                </div>:


                                <div class="col-md-3 margin-top-3px">

                                  <!--<div class="date-form">
                                    <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                           name="dp2" [(ngModel)]="ExtractionDate" ngbDatepicker #d2="ngbDatepicker" #DateOfBirth="ngModel">
                                    <small class="form-text text-danger"
                                           *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                    <a (click)="d2.toggle()" class="nav-link-hand">
                                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                    </a>

                                  </div>-->

                                  <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.DateOfSampleCollection | date:'MMM-dd-yyyy'}}</label>

                                </div>

                              </div>


                            </div>
                          </div>
                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3  text-align-right margin-top-3px ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Extraction Time </label>
                                </div>:


                                <div class="col-md-3 margin-top-3px">

                                  <!--<input type="time" class="form-control" id="CurrentSaveSpermDetailsRequest.ExtractionTime" placeholder="Extraction Time"
                                  [(ngModel)]="CurrentSaveSpermDetailsRequest.ExtractionTime"
                                  name="CurrentSaveSpermDetailsRequest.ExtractionTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />-->

                                  <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.ExtractionTimeText}}</label>

                                </div>

                              </div>


                            </div>
                          </div>

                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3  text-align-right margin-top-3px ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Storage Location </label>
                                </div>:


                                <div class="col-md-3 margin-top-3px">

                                  <!--<input type="text" class="form-control" placeholder="Storage Location" id="SpermEndInfo.StorageLocationDetails"
                                  [(ngModel)]="SpermEndInfo.StorageLocationDetails"
                                  name="SpermEndInfo.StorageLocationDetails" #Size="ngModel"
                                  maxlength="100">-->

                                  <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.StorageLocationDetails}}</label>

                                </div>

                              </div>


                            </div>
                          </div>
                          <div class="row my-profile-form" *ngIf="GradingModel=='Well Culture'">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3  text-align-right margin-top-3px ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Technique </label>
                                </div>:




                                <div class="col-md-5 margin-top-3px">
                                  <!--<CodeTypeValue CodeType="IVFSR" id="SpermEndInfo.SpermRetrieval"
                                                 [(ngModel)]="SpermEndInfo.SpermRetrieval" SelectedValue="SpermEndInfo.SpermRetrieval"
                                                 name="SpermEndInfo.SpermRetrieval" required>

                                  </CodeTypeValue>-->

                                  <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.SpermRetrieval}}</label>

                                </div>



                              </div>


                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div *ngIf="SpermEndInfo && SemanAnalysis2">
                <form class="form " novalidate="" (ngSubmit)="onSubmit2()" #f="ngForm">
                  <div class="accordion margin-bottom-20px" id="accordionExample5" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFive">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px"
                                      type="button" data-toggle="collapse" data-target="#collapseFive"
                                      aria-expanded="true" aria-controls="collapseFive">
                                Processing
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="SemanAnalysis2">
                            <button type="button"
                                    class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="submit"
                                    class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right"
                                    *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">
                            Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                          </div>

                        </div>


                      </div>

                      <div id="collapseFive" class="collapse show" aria-labelledby="headingFive" data-parent="#accordionExample5">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                          <div class="card margin-bottom-0px">

                            <div class="card-body padding-top-0px padding-bottom-0px">
                              <div class="row">
                                <div class="col-md-10 padding-right-0px">
                                  <div class="table-component">
                                    <div class="table-responsive">


                                      <table class="table table-striped margin-left-zero width-50-new overflow-y-hidden">

                                        <tr>

                                          <!--<th class="font-weight-normal  background-primary">

    </th>-->
                                          <!--<th class="font-weight-normal td-padding-tb background-primary font-size-12px">
      Occ
    </th>-->
                                          <!--<th class="font-weight-normal td-padding-tb background-primary font-size-12px">
      Denuded
    </th>-->












                                        </tr>
                                        <tr>
                                          <th rowspan="1" class="font-weight-normal  background-primary font-size-12px">
                                            Date of Sample Collection
                                          </th>
                                          <td class="td-padding-tb font-size-12px">
                                            <div class="date-form">
                                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                     name="dp1" [(ngModel)]="DateofSampleCollection" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                                              <small class="form-text text-danger"
                                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                              <a (click)="d1.toggle()" class="nav-link-hand">
                                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                              </a>

                                            </div>
                                          </td>
                                          <!--<td class="td-padding-tb font-size-12px">
      <div class="date-form">
        <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
               name="dp1" [(ngModel)]="EndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
        <small class="form-text text-danger"
               *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
        <a (click)="d1.toggle()" class="nav-link-hand">
          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

        </a>

      </div>
    </td>-->
                                        </tr>
                                        <tr>
                                          <th rowspan="1" class="font-weight-normal  background-primary font-size-12px">
                                            Time of Sample Collection
                                          </th>
                                          <td class="td-padding-tb font-size-12px">
                                            <input class="form-control" [ngxTimepicker]="picker" [(ngModel)]="SpermEndInfo.TimeOFSampleCollection" name="SpermEndInfo.TimeOFSampleCollection">
                                            <ngx-material-timepicker #picker></ngx-material-timepicker>
                                          </td>
                                          <td class="td-padding-tb font-size-12px">
                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.TimeOFSampleCollection| slice:11}}</label>
                                          </td>
                                          <!--<td class="td-padding-tb font-size-12px"> <input type="time" class="form-control" placeholder="Time"></td>-->
                                        </tr>
                                        <tr>
                                          <th rowspan="1" class="font-weight-normal  background-primary font-size-12px">
                                            Volume(ml)
                                          </th>
                                          <td class="td-padding-tb">
                                            <input type="number" class="form-control" placeholder="Volume" id="SpermEndInfo.Volume"
                                                   [(ngModel)]="SpermEndInfo.Volume"
                                                   name="SpermEndInfo.Volume" #NeedleName="ngModel"
                                                   maxlength="100" required>
                                          </td>
                                          <!--<td class="td-padding-tb"> <input type="number" class="form-control" placeholder="Volume"></td>-->
                                        </tr>
                                        <tr>
                                          <th rowspan="1" class="font-weight-normal  background-primary font-size-12px">
                                            Count(mil/ml)
                                          </th>
                                          <td class="td-padding-tb">
                                            <input type="number" class="form-control" placeholder="Count" id="SpermEndInfo.Count"
                                                   [(ngModel)]="SpermEndInfo.Count"
                                                   name="SpermEndInfo.Count" #Count="ngModel"
                                                   maxlength="100" required>
                                          </td>
                                          <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Count"></td>-->
                                        </tr>
                                        <tr *ngIf="GradingModel=='Well Culture'">
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Motile Sperm Motility(%)
                                          </th>
                                          <td class="td-padding-tb">
                                            <input type="number" class="form-control" placeholder="Motility" id="SpermEndInfo.MotileSpermMotility"
                                                   [(ngModel)]="SpermEndInfo.MotileSpermMotility"
                                                   name="SpermEndInfo.MotileSpermMotility" #Count="ngModel"
                                                   maxlength="100" required>
                                          </td>
                                          <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Motility"></td>-->
                                        </tr>

                                        <tr>
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px" *ngIf="GradingModel=='Well Culture'">
                                            Active Progressivemotility (%)
                                          </th>
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px" *ngIf="GradingModel=='Droplet Culture'">
                                            Total Motility(%)
                                          </th>
                                          <td class="td-padding-tb">
                                            <input type="number" class="form-control" placeholder="Active Progressivemotility" id="SpermEndInfo.ActiveProgressiveMotility"
                                                   [(ngModel)]="SpermEndInfo.ActiveProgressiveMotility"
                                                   name="SpermEndInfo.ActiveProgressiveMotility" #Count="ngModel"
                                                   maxlength="100" required>
                                          </td>
                                          <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Motility"></td>-->
                                        </tr>
                                        <tr *ngIf="GradingModel=='Droplet Culture'">
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Progressive Motility(%)
                                          </th>
                                          <td class="td-padding-tb">
                                            <input type="number" class="form-control" placeholder="Progressive Motility" id="SpermEndInfo.ProgressiveMotility"
                                                   [(ngModel)]="SpermEndInfo.ProgressiveMotility"
                                                   name="SpermEndInfo.ProgressiveMotility" #ProgressiveMotility="ngModel"
                                                   maxlength="100" required>
                                          </td>
                                          <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Motility"></td>-->
                                        </tr>
                                        <tr *ngIf="GradingModel=='Droplet Culture'">
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Slugish Motile(%)
                                          </th>
                                          <td class="td-padding-tb" *ngIf="SpermInfo">
                                            <input type="number" class="form-control" placeholder="SlugishMotile" id="SpermInfo.DataValue"
                                                   [(ngModel)]="SpermInfo.DataValue"
                                                   name="SpermInfo.DataValue" #SlugishMotile="ngModel"
                                                   maxlength="100" required>
                                          </td>
                                        </tr>
                                        <tr *ngIf="GradingModel=='Droplet Culture'">
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Viability(%)
                                          </th>
                                          <td class="td-padding-tb" *ngIf="Viability">
                                            <input type="number" class="form-control" placeholder="Viability" id="Viability.DataValue"
                                                   [(ngModel)]="Viability.DataValue"
                                                   name="Viability.DataValue" #viability="ngModel"
                                                   maxlength="100" required>
                                          </td>
                                        </tr>
                                        <tr *ngIf="GradingModel=='Droplet Culture'">
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Non-Progressive Motility(%)
                                          </th>
                                          <td class="td-padding-tb">
                                            <input type="number" class="form-control" placeholder="Non-Progressive Motility" id="SpermEndInfo.NonProgressiveMotility"
                                                   [(ngModel)]="SpermEndInfo.NonProgressiveMotility"
                                                   name="SpermEndInfo.NonProgressiveMotility" #NonProgressiveMotility="ngModel"
                                                   maxlength="100" required>
                                          </td>
                                          <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Motility"></td>-->
                                        </tr>
                                        <tr *ngIf="GradingModel=='Droplet Culture'">
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Immotile(%)
                                          </th>
                                          <td class="td-padding-tb">
                                            <input type="number" class="form-control" placeholder="Immotile" id="SpermEndInfo.Immotile"
                                                   [(ngModel)]="SpermEndInfo.Immotile"
                                                   name="SpermEndInfo.Immotile" #Immotile="ngModel"
                                                   maxlength="100" required>
                                          </td>
                                          <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Motility"></td>-->
                                        </tr>
                                        <tr *ngIf="GradingModel=='Droplet Culture'">
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Morphology(%)
                                          </th>
                                          <td class="td-padding-tb">
                                            <!--<input type="number" class="form-control" placeholder="Morphology" id="SpermEndInfo.Morphology"
      [(ngModel)]="SpermEndInfo.Morphology"
      name="SpermEndInfo.Morphology" #Morphology="ngModel"
      maxlength="100" required>-->
                                            <input type="number" class="form-control" placeholder="Morphology" id="SpermEndInfo.Morphology"
                                                   [(ngModel)]="SpermEndInfo.Morphology"
                                                   name="SpermEndInfo.Morphology" #Morphology="ngModel"
                                                   maxlength="100" required>
                                            <!--<CodeTypeValue CodeType="IVFSM" id="SpermEndInfo.Morphology"
      [(ngModel)]="SpermEndInfo.Morphology" SelectedValue="SpermEndInfo.Morphology"
      name="SpermEndInfo.Morphology"></CodeTypeValue>-->
                                          </td>

                                          <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Motility"></td>-->
                                        </tr>
                                        <tr>
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Cellular Debris
                                          </th>
                                          <td class="td-padding-tb">
                                            <CodeTypeValue CodeType="IVFCD" id="SpermEndInfo.CellularDebris"
                                                           [(ngModel)]="SpermEndInfo.CellularDebris" SelectedValue="SpermEndInfo.CellularDebris"
                                                           name="SpermEndInfo.CellularDebris"></CodeTypeValue>
                                          </td>
                                          <!--<td class="td-padding-tb"><CodeTypeValue CodeType="FNSTS"></CodeTypeValue></td>-->
                                        </tr>
                                        <tr>
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Method of Preparation
                                          </th>
                                          <td class="td-padding-tb">
                                            <CodeTypeValue CodeType="IVFMP" id="SpermEndInfo.MethodofPreparation"
                                                           [(ngModel)]="SpermEndInfo.MethodOfPreparation" SelectedValue="SpermEndInfo.MethodOfPreparation"
                                                           name="SpermEndInfo.MethodOfPreparation"></CodeTypeValue>
                                          </td>
                                          <!--<td class="td-padding-tb"><CodeTypeValue CodeType="FNSTS"></CodeTypeValue></td>-->
                                        </tr>
                                        <tr>
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Incubation Time (In Min)
                                          </th>
                                          <td class="td-padding-tb" *ngIf="GradingModel=='Well Culture'">
                                            <input type="number" class="form-control" placeholder="Incubation Time" id="SpermEndInfo.IncubationTime"
                                                   [(ngModel)]="SpermEndInfo.IncubationTime"
                                                   name="SpermEndInfo.IncubationTime" #IncubationTime="ngModel"
                                                   maxlength="100" required>
                                          </td>
                                          <td class="td-padding-tb" *ngIf="GradingModel=='Droplet Culture'">
                                            <CodeTypeValue CodeType="IVFIT" id="SpermEndInfo.IncubationTime"
                                                           [(ngModel)]="SpermEndInfo.IncubationTime" SelectedValue="SpermEndInfo.IncubationTime"
                                                           name="SpermEndInfo.IncubationTime"></CodeTypeValue>
                                          </td>
                                          <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Time"></td>-->
                                        </tr>
                                        <tr hidden>
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Motile Sperm Count(mil/ml)
                                          </th>
                                          <td class="td-padding-tb">
                                            <input type="number" class="form-control" placeholder="Sperm Count" id="SpermEndInfo.MotileSpermCount"
                                                   [(ngModel)]="SpermEndInfo.MotileSpermCount"
                                                   name="SpermEndInfo.MotileSpermCount" #MotileSpermCount="ngModel"
                                                   maxlength="100" required>
                                          </td>
                                          <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Sperm Count"></td>-->
                                        </tr>
                                        <tr hidden>
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Motility(%)
                                          </th>
                                          <td class="td-padding-tb">
                                            <input type="number" class="form-control" placeholder="Motility" id="SpermEndInfo.Motility"
                                                   [(ngModel)]="SpermEndInfo.Motility"
                                                   name="SpermEndInfo.Motility" #Motility="ngModel"
                                                   maxlength="100" required>
                                          </td>
                                          <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Motility"></td>-->
                                        </tr>



                                        <tr *ngIf="GradingModel=='Droplet Culture'">
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            DFI(%)
                                          </th>
                                          <td class="td-padding-tb">
                                            <input type="number" class="form-control" placeholder="DFI" id="SpermEndInfo.DFI"
                                                   [(ngModel)]="SpermEndInfo.DFI"
                                                   name="SpermEndInfo.DFI" #DFI="ngModel"
                                                   maxlength="100" required>
                                          </td>
                                          <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Motility"></td>-->
                                        </tr>
                                        <tr>
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Notes
                                          </th>
                                          <td class="td-padding-tb">
                                            <input type="text" class="form-control" placeholder="Notes" id="SpermEndInfo.Notes"
                                                   [(ngModel)]="SpermEndInfo.Notes"
                                                   name="SpermEndInfo.Notes" #Notes="ngModel"
                                                   maxlength="100" required>
                                          </td>
                                          <!--<td class="td-padding-tb"><input type="text" class="form-control" placeholder="Notes"></td>-->
                                        </tr>
                                        <tr *ngIf="GradingModel=='Well Culture'">
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Slide Observed?
                                          </th>
                                          <td class="td-padding-tb"><input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="SpermEndInfo.SlideObserved" name="SpermEndInfo.SlideObserved"></td>
                                          <!--<td class="td-padding-tb"><CodeTypeValue CodeType="FNSTS"></CodeTypeValue></td>-->
                                        </tr>
                                      </table>

                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div *ngIf="SpermEndInfo && SemanAnalysis2">
                <form class="form " novalidate="" (ngSubmit)="onSubmit2()" #f="ngForm">
                  <div class="accordion margin-bottom-20px" id="accordionExample5" *ngIf="SemanAnalysis2.ActivityStatus =='Completed'">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFive">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px"
                                      type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
                                Processing
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="SemanAnalysis2">
                            <button type="button"
                                    class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                          </div>

                        </div>


                      </div>

                      <div id="collapseFive" class="collapse show" aria-labelledby="headingFive" data-parent="#accordionExample5">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                          <div class="card margin-bottom-0px">

                            <div class="card-body padding-top-0px padding-bottom-0px">
                              <div class="row">
                                <div class="col-md-10 padding-right-0px">
                                  <div class="table-component">
                                    <div class="table-responsive">


                                      <table class="table table-striped margin-left-zero width-50-new overflow-y-hidden">

                                        <tr></tr>
                                        <tr>
                                          <th rowspan="1" class="font-weight-normal  background-primary font-size-12px">
                                            Date of Sample Collection
                                          </th>
                                          <td class="td-padding-tb font-size-12px">
                                            <!--<div class="date-form">
                                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                     name="dp1" [(ngModel)]="DateofSampleCollection" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                                              <small class="form-text text-danger"
                                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                              <a (click)="d1.toggle()" class="nav-link-hand">
                                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                              </a>

                                            </div>-->
                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.DateOfSampleCollection | date:'MMM-dd-yyyy'}}</label>
                                          </td>

                                        </tr>
                                        <tr>
                                          <th rowspan="1" class="font-weight-normal  background-primary font-size-12px">
                                            Time of Sample Collection
                                          </th>
                                          <td class="td-padding-tb font-size-12px">
                                            <!--<input class="form-control" [ngxTimepicker]="picker" [(ngModel)]="SpermEndInfo.TimeOFSampleCollection" name="SpermEndInfo.TimeOFSampleCollection">
                                            <ngx-material-timepicker #picker></ngx-material-timepicker>-->
                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.TimeOFSampleCollection| slice:11}}</label>
                                          </td>

                                        </tr>
                                        <tr>
                                          <th rowspan="1" class="font-weight-normal  background-primary font-size-12px">
                                            Volume(ml)
                                          </th>
                                          <td class="td-padding-tb">
                                            <!--<input type="number" class="form-control" placeholder="Volume" id="SpermEndInfo.Volume"
                                            [(ngModel)]="SpermEndInfo.Volume"
                                            name="SpermEndInfo.Volume" #NeedleName="ngModel"
                                            maxlength="100" required>-->
                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.Volume}}</label>
                                          </td>

                                        </tr>
                                        <tr>
                                          <th rowspan="1" class="font-weight-normal  background-primary font-size-12px">
                                            Count(mil/ml)
                                          </th>
                                          <td class="td-padding-tb">
                                            <!--<input type="number" class="form-control" placeholder="Count" id="SpermEndInfo.Count"
                                            [(ngModel)]="SpermEndInfo.Count"
                                            name="SpermEndInfo.Count" #Count="ngModel"
                                            maxlength="100" required>-->
                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.Count}}</label>
                                          </td>

                                        </tr>
                                        <tr *ngIf="GradingModel=='Well Culture'">
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Motile Sperm Motility(%)
                                          </th>
                                          <td class="td-padding-tb">
                                            <!--<input type="number" class="form-control" placeholder="Motility" id="SpermEndInfo.MotileSpermMotility"
                                            [(ngModel)]="SpermEndInfo.MotileSpermMotility"
                                            name="SpermEndInfo.MotileSpermMotility" #Count="ngModel"
                                            maxlength="100" required>-->
                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.MotileSpermMotility}}</label>
                                          </td>

                                        </tr>

                                        <tr>
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px" *ngIf="GradingModel=='Well Culture'">
                                            Active Progressivemotility (%)
                                          </th>
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px" *ngIf="GradingModel=='Droplet Culture'">
                                            Total Motility(%)
                                          </th>
                                          <td class="td-padding-tb">
                                            <!--<input type="number" class="form-control" placeholder="Active Progressivemotility" id="SpermEndInfo.ActiveProgressiveMotility"
                                            [(ngModel)]="SpermEndInfo.ActiveProgressiveMotility"
                                            name="SpermEndInfo.ActiveProgressiveMotility" #Count="ngModel"
                                            maxlength="100" required>-->
                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.ActiveProgressiveMotility}}</label>
                                          </td>

                                        </tr>
                                        <tr *ngIf="GradingModel=='Droplet Culture'">
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Progressive Motility(%)
                                          </th>
                                          <td class="td-padding-tb">
                                            <!--<input type="number" class="form-control" placeholder="Progressive Motility" id="SpermEndInfo.ProgressiveMotility"
                                            [(ngModel)]="SpermEndInfo.ProgressiveMotility"
                                            name="SpermEndInfo.ProgressiveMotility" #ProgressiveMotility="ngModel"
                                            maxlength="100" required>-->
                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.ProgressiveMotility}}</label>
                                          </td>

                                        </tr>
                                        <tr *ngIf="GradingModel=='Droplet Culture'">
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Slugish Motile(%)
                                          </th>
                                          <td class="td-padding-tb" *ngIf="SpermInfo">
                                            <label class="font-size-12px margin-bottom-0px">{{SpermInfo.DataValue}}</label>
                                          </td>

                                        </tr>
                                        <tr *ngIf="GradingModel=='Droplet Culture'">
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Viability(%)
                                          </th>
                                          <td class="td-padding-tb" *ngIf="Viability">
                                            <label class="font-size-12px margin-bottom-0px">{{Viability.DataValue}}</label>
                                          </td>

                                        </tr>
                                        <tr *ngIf="GradingModel=='Droplet Culture'">
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Non-Progressive Motility(%)
                                          </th>
                                          <td class="td-padding-tb">
                                            <!--<input type="number" class="form-control" placeholder="Non-Progressive Motility" id="SpermEndInfo.NonProgressiveMotility"
                                            [(ngModel)]="SpermEndInfo.NonProgressiveMotility"
                                            name="SpermEndInfo.NonProgressiveMotility" #NonProgressiveMotility="ngModel"
                                            maxlength="100" required>-->
                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.NonProgressiveMotility}}</label>
                                          </td>

                                        </tr>
                                        <tr *ngIf="GradingModel=='Droplet Culture'">
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Immotile(%)
                                          </th>
                                          <td class="td-padding-tb">
                                            <!--<input type="number" class="form-control" placeholder="Immotile" id="SpermEndInfo.Immotile"
                                            [(ngModel)]="SpermEndInfo.Immotile"
                                            name="SpermEndInfo.Immotile" #Immotile="ngModel"
                                            maxlength="100" required>-->
                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.Immotile}}</label>
                                          </td>

                                        </tr>
                                        <tr *ngIf="GradingModel=='Droplet Culture'">
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Morphology(%)
                                          </th>
                                          <td class="td-padding-tb">

                                            <!--<input type="number" class="form-control" placeholder="Morphology" id="SpermEndInfo.Morphology"
                                            [(ngModel)]="SpermEndInfo.Morphology"
                                            name="SpermEndInfo.Morphology" #Morphology="ngModel"
                                            maxlength="100" required>-->
                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.Morphology}}</label>
                                          </td>

                                        </tr>
                                        <tr>
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Cellular Debris
                                          </th>
                                          <td class="td-padding-tb">
                                            <!--<CodeTypeValue CodeType="IVFCD" id="SpermEndInfo.CellularDebris"
                                               [(ngModel)]="SpermEndInfo.CellularDebris" SelectedValue="SpermEndInfo.CellularDebris"
                                               name="SpermEndInfo.CellularDebris"></CodeTypeValue>-->
                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.CellularDebris}}</label>
                                          </td>

                                        </tr>
                                        <tr>
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Method of Preparation
                                          </th>
                                          <td class="td-padding-tb">
                                            <!--<CodeTypeValue CodeType="IVFMP" id="SpermEndInfo.MethodofPreparation"
                                               [(ngModel)]="SpermEndInfo.MethodOfPreparation" SelectedValue="SpermEndInfo.MethodOfPreparation"
                                               name="SpermEndInfo.MethodOfPreparation"></CodeTypeValue>-->
                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.MethodOfPreparation}}</label>
                                          </td>

                                        </tr>
                                        <tr>
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Incubation Time (In Min)
                                          </th>
                                          <td class="td-padding-tb" *ngIf="GradingModel=='Well Culture'">
                                            <!--<input type="number" class="form-control" placeholder="Incubation Time" id="SpermEndInfo.IncubationTime"
                                            [(ngModel)]="SpermEndInfo.IncubationTime"
                                            name="SpermEndInfo.IncubationTime" #IncubationTime="ngModel"
                                            maxlength="100" required>-->
                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.IncubationTime}}</label>
                                          </td>
                                          <td class="td-padding-tb" *ngIf="GradingModel=='Droplet Culture'">
                                            <!--<CodeTypeValue CodeType="IVFIT" id="SpermEndInfo.IncubationTime"
                                               [(ngModel)]="SpermEndInfo.IncubationTime" SelectedValue="SpermEndInfo.IncubationTime"
                                               name="SpermEndInfo.IncubationTime"></CodeTypeValue>-->
                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.IncubationTime}}</label>
                                          </td>

                                        </tr>
                                        <tr hidden>
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Motile Sperm Count(mil/ml)
                                          </th>
                                          <td class="td-padding-tb">
                                            <!--<input type="number" class="form-control" placeholder="Sperm Count" id="SpermEndInfo.MotileSpermCount"
                                            [(ngModel)]="SpermEndInfo.MotileSpermCount"
                                            name="SpermEndInfo.MotileSpermCount" #MotileSpermCount="ngModel"
                                            maxlength="100" required>-->
                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.MotileSpermCount}}</label>
                                          </td>

                                        </tr>
                                        <tr hidden>
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Motility(%)
                                          </th>
                                          <td class="td-padding-tb">
                                            <!--<input type="number" class="form-control" placeholder="Motility" id="SpermEndInfo.Motility"
                                            [(ngModel)]="SpermEndInfo.Motility"
                                            name="SpermEndInfo.Motility" #Motility="ngModel"
                                            maxlength="100" required>-->
                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.Motility}}</label>
                                          </td>

                                        </tr>



                                        <tr *ngIf="GradingModel=='Droplet Culture'">
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            DFI(%)
                                          </th>
                                          <td class="td-padding-tb">
                                            <!--<input type="number" class="form-control" placeholder="DFI" id="SpermEndInfo.DFI"
                                            [(ngModel)]="SpermEndInfo.DFI"
                                            name="SpermEndInfo.DFI" #DFI="ngModel"
                                            maxlength="100" required>-->
                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.DFI}}</label>
                                          </td>

                                        </tr>
                                        <tr>
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Notes
                                          </th>
                                          <td class="td-padding-tb">
                                            <!--<input type="text" class="form-control" placeholder="Notes" id="SpermEndInfo.Notes"
                                            [(ngModel)]="SpermEndInfo.Notes"
                                            name="SpermEndInfo.Notes" #Notes="ngModel"
                                            maxlength="100" required>-->
                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.Notes}}</label>
                                          </td>

                                        </tr>
                                        <tr *ngIf="GradingModel=='Well Culture'">
                                          <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                            Slide Observed?
                                          </th>
                                          <td class="td-padding-tb"><input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="SpermEndInfo.SlideObserved" name="SpermEndInfo.SlideObserved"></td>

                                        </tr>
                                      </table>

                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div>
                <div *ngIf="SpermSourceInfo && GradingModel=='Well Culture'">
                  <form class="form " novalidate="" (ngSubmit)="onSubmitStore()" #f="ngForm">
                    <div class="accordion margin-bottom-20px" id="accordionExample4">
                      <div class="card margin-bottom-5px">
                        <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFour">
                          <div class="row">
                            <div class="col-md-4">
                              <h5 class="mb-0 height-24px">
                                <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                                  Storage
                                </button>
                              </h5>
                            </div>
                            <div class="col-md-8 " *ngIf="SemanAnalysis2">
                              <button type="button"
                                      class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                              <button type="submit"
                                      class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right"
                                      *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">
                              Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                            </div>
                          </div>


                        </div>

                        <div id="collapseFour" class="collapse show" aria-labelledby="headingFour" data-parent="#accordionExample4">
                          <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                            <div class="row my-profile-form">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                <div class="row">
                                  <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Storage Type </label>
                                  </div>


                                  <div class="col-md-3">
                                    <CodeTypeValue CodeType="IVFSP"
                                                   id="SpermSourceInfo.StorageUnitType"
                                                   [(ngModel)]="SpermSourceInfo.StorageUnitType" SelectedValue="SpermSourceInfo.StorageUnitType"
                                                   name="SpermSourceInfo.StorageUnitType" required>

                                    </CodeTypeValue>


                                  </div>

                                </div>


                              </div>
                            </div>
                            <div class="row my-profile-form">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                <div class="row">
                                  <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Volume </label>
                                  </div>


                                  <div class="col-md-2">

                                    <input type="text" class="form-control" placeholder="Volume"
                                           id="SpermSourceInfo.Volume"
                                           [(ngModel)]="SpermSourceInfo.Volume"
                                           name="SpermSourceInfo.Volume" #Endometrium="ngModel"
                                           maxlength="100" required>
                                    <small class="form-text text-danger"
                                           *ngIf="(!Endometrium.valid && (Endometrium.dirty || Endometrium.touched) && Endometrium.errors.required )">(Field cannot be left blank)</small>
                                    <small class="form-text text-danger"
                                           *ngIf="(!Endometrium.valid && Endometrium.errors.pattern)">(special characters are not allowed)</small>

                                  </div>
                                  <div class="col-md-2">
                                    <CodeTypeValue CodeType="SEVU"
                                                   id="SpermSourceInfo.VolumeUnits"
                                                   [(ngModel)]="SpermSourceInfo.VolumeUnits" SelectedValue="SpermSourceInfo.VolumeUnits"
                                                   name="SpermSourceInfo.VolumeUnits">
                                    </CodeTypeValue>


                                  </div>
                                </div>


                              </div>
                            </div>
                            <div class="row my-profile-form">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-3 padding-right-0px text-align-right">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Details</label>
                                  </div>

                                  <div class="col-md-4 padding-right-0px">
                                    <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Details"
                                              name="SpermSourceInfo.StorageUnitDetails"
                                              [(ngModel)]="SpermSourceInfo.StorageUnitDetails" required minlength="1" maxlength="100"
                                              #addconcerns_text="ngModel"></textarea>
                                    <small class="form-text text-danger"
                                           *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>

                                  </div>
                                </div>


                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
